import { render } from "./FamilyIncomeBenefitExpressQuestion.vue?vue&type=template&id=177e379a&scoped=true"
import script from "./FamilyIncomeBenefitExpressQuestion.vue?vue&type=script&lang=js"
export * from "./FamilyIncomeBenefitExpressQuestion.vue?vue&type=script&lang=js"

import "./FamilyIncomeBenefitExpressQuestion.vue?vue&type=style&index=0&id=177e379a&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\ProtectionGuruVue\\client-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-177e379a"]])

export default __exports__